/* src/app/component/review-modal/review-modal.component.scss */
.btn-1 {
  display: inline-block;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  border-radius: 8px;
  padding: 10px 18px;
  cursor: pointer;
  transition:
    background-color 0.3s,
    color 0.3s,
    border-color 0.3s;
}
.btn-warning-1 {
  background-color: white;
  color: #000;
  border: 1px solid #D0D5DD;
}
.btn {
  font-size: 14px;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  border: none;
  height: 40px;
}
.btn-cancel {
  background-color: #fff;
  color: #000;
  border: 1px solid #D0D5DD;
}
.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.reviewcontent {
  color: #102810;
  font-size: 16px;
}
.selectSA {
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  color: #344054;
}
.btn-warning-1:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
textarea {
  border-radius: 10px;
  padding: 10px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  color: #667085;
}
textarea::placeholder {
  color: #667085;
}
::ng-deep .custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 15px;
}
::ng-deep .custom-table thead th {
  background-color: #f8f9fa;
  color: #495057;
  padding: 10px;
  font-weight: 600;
  text-align: left;
  border-bottom: 2px solid #dee2e6;
  border-top: 1px solid #dee2e6;
}
::ng-deep .custom-table tbody tr {
  background-color: white;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease;
}
::ng-deep .custom-table tbody tr:hover {
  background-color: #f1f3f5;
}
::ng-deep .custom-table td {
  padding: 10px;
  border: none;
}
::ng-deep .custom-table td:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
::ng-deep .custom-table td:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
::ng-deep .custom-table p-radioButton {
  margin: 0 auto;
  display: block;
}
::ng-deep .custom-table thead th:first-child,
.custom-table tbody td:first-child {
  padding-left: 20px;
}
::ng-deep .custom-table thead th:last-child,
.custom-table tbody td:last-child {
  padding-right: 20px;
}
::ng-deep .custom-table tr td {
  text-align: center;
  vertical-align: middle;
  font-size: 14px;
}
::ng-deep .custom-table .p-radioButton .p-radiobutton-box {
  border-radius: 50%;
  border: 1px solid #d92d20;
  width: 20px;
  height: 20px;
}
::ng-deep .custom-table .p-radioButton .p-radiobutton-icon {
  color: #d92d20;
}
::ng-deep .custom-table .p-radiobutton:focus .p-radiobutton-box {
  box-shadow: 0 0 5px #d92d20;
}
/*# sourceMappingURL=review-modal.component-P7EEPAWS.css.map */
